import { getPostByName, getRelatedPosts, getUser } from '$lib/utils/blogClient';

export async function load({ params, url, fetch }) {
  var isLoading = false;

  const idPost = params.idPost;
  const password = url.searchParams.get('password');

  try {
    let data = await getPostByName(fetch, idPost, password);
    const post = data[0];

    var relatedPosts = [];
    var user = null;

    if (!(post.excerpt.protected && post.excerpt.rendered === '')) {
      user = await getUser(fetch, post.author);
      relatedPosts = await getRelatedPosts(fetch, post.id, password);
    }

    return { post, relatedPosts, user, isLoading };
  } catch (error) {
    return { status: 500, error: new Error('Failed to load launch details') };
  }
}
